import { type ReactElement } from "react";
import { Text, Box, Stack } from "@citibox-panel/ui";

export function LayoutDemo(): ReactElement {
  return (
    <>
      <Text variant="subtitle2" component="h3" gutterBottom>
        Stack horizontal con cajas
      </Text>
      <Stack direction="row" spacing={2}>
        <Box
          sx={{
            bgcolor: "primary.main",
            color: "primary.contrastText",
            p: 2,
            borderRadius: 1,
          }}
        >
          Box A
        </Box>
        <Box
          sx={{
            bgcolor: "secondary.main",
            color: "secondary.contrastText",
            p: 2,
            borderRadius: 1,
          }}
        >
          Box B
        </Box>
        <Box sx={{ bgcolor: "action.selected", p: 2, borderRadius: 1 }}>
          Box C
        </Box>
      </Stack>
    </>
  );
}
